import { AxiosResponse, AxiosInstance } from "axios";
export interface UpdateInstancePayload {
    description: string;
}

export function fetchLicensedInstances(
    axiosInstance: AxiosInstance,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/list?tenantId=${tenantId}`);
}

export function fetchLicensedInstanceById(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`);
}

export function updateLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number,
    payload: UpdateInstancePayload
): Promise<AxiosResponse> {
    return axiosInstance.put(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`, payload);
}

export function deleteLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.delete(`/ctxr/-1/RemoveLicense/${instanceId}?tenantId=${tenantId}`);
}

/**
 * Respuesta de `DELETE /ctxr/:suscriptionId/:id`. El backend rechaza con HTTP 200
 * y `error` (p. ej. una instancia en cluster), así que un 2xx no basta para dar
 * el borrado por hecho.
 */
export interface DeleteInstanceResponse {
    status?: string;
    error?: string;
}

/**
 * Borra la instancia de verdad. Si tiene licencia, el backend la libera en el
 * mismo DELETE, así que no se llama `RemoveLicense` antes. No confundir con
 * `deleteLicensedInstance`, que solo libera la licencia y la deja en Unlicensed.
 */
export function deleteInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number
): Promise<AxiosResponse<DeleteInstanceResponse>> {
    return axiosInstance.delete(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`);
}
